var Shopify = Shopify || {};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function updateSizeForAU(targetSelector) {
  if(currentPath == "au.manieredevoir.com") {
    jQuery(targetSelector).each(function() {
        jQuery(this).text(jQuery(this).text().replace(/UK/g, 'AU'));
        jQuery(this).text(jQuery(this).text().replace(/uk/g, 'au'));
    });
  }
}

$(document).ready(function (e) {
updateSizeForAU('.size_swatch .option_selector');

    // head-sticky
    // D12 fix: the previous handler rewrote the head-sticky classes on every
    // scroll event (many fire per frame). On mobile/tablet those redundant
    // per-frame style writes forced the position:sticky header to recompute
    // mid-scroll, so it visibly jittered/shifted and could momentarily blank
    // out while scrolling up and down. rAF-throttle the read and only touch the
    // DOM when the sticky state actually changes; the 20px threshold and the
    // toggled classes are unchanged.
    var headStickyState = null;
    var headStickyTicking = false;
    function updateHeadSticky() {
        headStickyTicking = false;
        var shouldStick = $(window).scrollTop() >= 20;
        if (shouldStick === headStickyState) return;
        headStickyState = shouldStick;
        $(".header-style-one, .header").toggleClass("head-sticky", shouldStick);
    }
    $(window).scroll(function () {
        if (headStickyTicking) return;
        headStickyTicking = true;
        requestAnimationFrame(updateHeadSticky);
    });
  
  
    var shop_money_format = $('body').attr('data-shop-moneyformat');
    var shop_money_with_currency_format = $('body').attr('data-shop-money-with-currency-format') || shop_money_format;
    if(sale_timer == true){
    var current_date = new Date();
    var start_time=Math.ceil((current_date.getTime()+ current_date.getTimezoneOffset())/ 1000);
    var a = new Date(start_time*1000);
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var dayOfWeek = days[a.getDay()];
    var hours_setup=22;
    if(dayOfWeek=='Sunday'){
      hours_setup=16;
    }else{
      hours_setup=22;
    }
    function datetime_counter(){
    var start = new Date() ;
    var start_time_c=Math.ceil((start.getTime()+ start.getTimezoneOffset())/ 1000);
    var gmttime=checktime(start_time_c);
    var myDate=new Date();

    myDate.setHours(hours_setup);
    myDate.setMinutes(0);

    var end = myDate;
    var timeDiff = Math.abs(end.getTime() - (start.getTime()+ start.getTimezoneOffset()*60000)); // in miliseconds
    var timeDiffInSecond = Math.ceil(timeDiff / 1000);
    var hrs = end.getHours() - start.getHours();
    var min = end.getMinutes() - start.getMinutes();
    var sec = end.getSeconds() - start.getSeconds();

    var hour_carry = 0;
    var minutes_carry = 0;
    if(min < 0){
      min += 60;
      hour_carry += 1;
    }
    hrs = hrs - hour_carry;
    if(sec < 0){
      sec += 60;
      minutes_carry += 1;
    }

    min = min - minutes_carry;
    $('.timmer_span').html(seconds_to_days_hours_mins_secs_str(timeDiffInSecond));
  }

  $(document).ready(function(){
    var i = 0;
    if(dayOfWeek!='Saturday'){
      datetime_counter();
    }
    if(count_down_date){
      live_datetime_counter();
    }
    $(function() {
      if(dayOfWeek!='Saturday'){
        setInterval(datetime_counter, 1000);
      }
      if(count_down_date){
        setInterval(live_datetime_counter, 1000);
      }
    });
  });
  function live_checktime(seconds)
  { 
    var days     = Math.floor(seconds / (24*60*60));
    seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
    seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
    seconds -= minutes * (60);
    return hours+":"+minutes;
  }
  function live_datetime_counter(){
    var start = new Date() ;
    var myDate=new Date(count_down_date);
    var end = myDate;
    var timeDiff = Math.abs(end.getTime() - (start.getTime()+ start.getTimezoneOffset()*60000)); // in miliseconds
    var timeDiffInSecond = Math.ceil(timeDiff / 1000);

    var start_time=Math.ceil((start.getTime()+ start.getTimezoneOffset())/ 1000);
    var gmttime=live_checktime(start_time);
    var hrs = end.getHours() - start.getHours();
    var min = end.getMinutes() - start.getMinutes(); 
    var sec = end.getSeconds() - start.getSeconds();  

    var hour_carry = 0;
    var minutes_carry = 0;
    if(min < 0){
      min += 60;
      hour_carry += 1;
    }
    hrs = hrs - hour_carry;
    if(sec < 0){
      sec += 60;
      minutes_carry += 1;
    }
    min = min - minutes_carry;
    $('.live_timmer_span').html(seconds_to_days_hours_mins_secs_str(timeDiffInSecond));
  }
  function checktime(seconds)
  { 
    var days     = Math.floor(seconds / (24*60*60));
    seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
    seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
    seconds -= minutes * (60);
    return hours+":"+minutes;
  }

  function seconds_to_days_hours_mins_secs_str(seconds)
{ 
  var days     = Math.floor(seconds / (24*60*60));
  seconds -= days * (24*60*60);

  var hours    = Math.floor(seconds / (60*60));
  seconds -= hours * (60*60);

  var minutes  = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  var day_str;
  var hour_str;
  var minute_str;
  var second_str;
  var separator_str;

  if(days==1){
    day_str = "<span style='font-size:8px !important; display:inline !important; visibility:visible !important;'>D</span> ";
  }else{
    day_str = "<span style='font-size:8px !important; display:inline !important; visibility:visible !important;'>D</span> ";
  }

  hour_str      = "<span style='font-size:8px !important; display:inline !important; visibility:visible !important;'>H</span> ";
  minute_str    = "<span style='font-size:8px !important; display:inline !important; visibility:visible !important;'>M</span> ";
  second_str    = "<span style='font-size:8px !important; display:inline !important; visibility:visible !important;'>S</span> ";
  separator_str = "<span style='margin:0 7px;display:inline !important; visibility:visible !important;'>:</span>";

  return ((0<days)?(days+day_str+separator_str):"")
    + hours + hour_str + separator_str
    + minutes + minute_str + separator_str
    + seconds + second_str;
}
    }
  
  // if($(".two_image_video_slider").length > 0){
  //   $('.two_image_video_slider').slick({
  //       dots: false,
  //       infinite: true,
  //       arrows: false,
  //       speed: 2000,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       adaptiveHeight: true,
  //       autoplay: true,
  //       autoplaySpeed: 6000,
  //       responsive: [
  //           {
  //               breakpoint: 767,
  //               settings: {
  //                   autoplay: false
  //               }
  //           }
  //       ]
  //   });
  // }

/* BEGIN MDV FREE DELIVERY PROGRESS RUNTIME V1 */
function mdvResetFreeDeliveryProgress() {
  document.querySelectorAll('.min-cart:not(.cart-page) .free-delivery-progress').forEach(function(progress) {
    var fill = progress.querySelector('.free-delivery-progress__fill');
    progress.hidden = true;
    progress.classList.remove('is-qualified');
    progress.setAttribute('aria-valuenow', '0');
    progress.setAttribute('aria-valuetext', 'Free delivery progress unavailable');
    if (fill) fill.style.width = '0%';
  });
}

function mdvUpdateFreeDeliveryProgress(qualifyingTotal, threshold) {
  var total = Number(qualifyingTotal);
  var target = Number(threshold);

  if (!Number.isFinite(total) || !Number.isFinite(target) || total <= 0 || target <= 0) {
    mdvResetFreeDeliveryProgress();
    return;
  }

  var percentage = Math.max(0, Math.min(100, (total / target) * 100));
  var roundedPercentage = Math.round(percentage);
  var qualified = total >= target;

  document.querySelectorAll('.min-cart:not(.cart-page) .free-delivery-progress').forEach(function(progress) {
    var fill = progress.querySelector('.free-delivery-progress__fill');
    progress.hidden = false;
    progress.classList.toggle('is-qualified', qualified);
    progress.setAttribute('aria-valuenow', String(roundedPercentage));
    progress.setAttribute(
      'aria-valuetext',
      qualified ? 'Qualified for free delivery' : roundedPercentage + '% towards free delivery'
    );
    if (fill) fill.style.width = percentage + '%';
  });
}
/* END MDV FREE DELIVERY PROGRESS RUNTIME V1 */

// mini-cart function
/* BEGIN MDV BAG CONTEXT RUNTIME V1 */
window.MDVBagContextCore = (function () {
  'use strict';

  function normalizedCode(value, length) {
    var code = String(value || '').trim().toUpperCase();
    return new RegExp('^[A-Z]{' + length + '}$').test(code) ? code : '';
  }

  function routeRoot(shopify) {
    var value = shopify && shopify.routes && shopify.routes.root;
    return typeof value === 'string' && /^\/[a-z]{0,2}(?:-[a-z]{2})?\/?$/i.test(value) ? value : '/';
  }

  function countryQueryValue(search, expectedCountry) {
    var values;
    try { values = new URLSearchParams(String(search || '')).getAll('country'); } catch (error) { return ''; }
    if (values.length !== 1) return '';
    var country = normalizedCode(values[0], 2);
    return country && country === normalizedCode(expectedCountry, 2) ? country : '';
  }

  function readCookie(win, name) {
    try {
      if (typeof win.getCookie === 'function') return String(win.getCookie(name) || '');
      var match = String(win.document.cookie || '').match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function captureContext(win) {
    var shopify = win.Shopify || {};
    var currency = shopify.currency || {};
    var rate = Number(currency.rate);
    var country = normalizedCode(shopify.country, 2);
    return {
      country: country,
      currency: normalizedCode(currency.active, 3),
      rate: Number.isFinite(rate) && rate > 0 ? rate : null,
      root: routeRoot(shopify),
      hostname: String(win.location && win.location.hostname || '').toLowerCase(),
      selectedCountry: normalizedCode(readCookie(win, 'selectedCountry'), 2),
      queryCountry: countryQueryValue(win.location && win.location.search, country)
    };
  }

  function sameContext(left, right) {
    return Boolean(left && right) && left.country === right.country && left.currency === right.currency &&
      left.rate === right.rate && left.root === right.root && left.hostname === right.hostname &&
      left.selectedCountry === right.selectedCountry && left.queryCountry === right.queryCountry;
  }

  function nonNegativeInteger(value) {
    var text = String(value == null ? '' : value).trim();
    return /^\d+$/.test(text) && Number.isSafeInteger(Number(text)) ? Number(text) : null;
  }

  function parseSnapshotHtml(html, context, Parser) {
    if (typeof html !== 'string' || !html || typeof Parser !== 'function') return null;
    var parsed = new Parser().parseFromString(html, 'text/html');
    if (!parsed || !parsed.body || typeof parsed.querySelectorAll !== 'function') return null;
    var markers = parsed.querySelectorAll('[data-mdv-bag-snapshot]');
    if (!markers || markers.length !== 1) return null;
    var marker = markers[0];
    var snapshot = {
      country: normalizedCode(marker.getAttribute('data-country'), 2),
      currency: normalizedCode(marker.getAttribute('data-currency'), 3),
      item_count: nonNegativeInteger(marker.getAttribute('data-item-count')),
      total_price: nonNegativeInteger(marker.getAttribute('data-total-price')),
      total_formatted: String(marker.getAttribute('data-total-formatted') || '').trim(),
      delivery_qualifying_total: nonNegativeInteger(marker.getAttribute('data-delivery-total')),
      min_order_item_count: nonNegativeInteger(marker.getAttribute('data-min-order-item-count'))
    };
    if (!snapshot.country || !snapshot.currency || snapshot.item_count === null || snapshot.total_price === null ||
        !snapshot.total_formatted || snapshot.delivery_qualifying_total === null || snapshot.min_order_item_count === null ||
        snapshot.min_order_item_count > snapshot.item_count || snapshot.country !== context.country ||
        snapshot.currency !== context.currency) return null;
    if (typeof marker.remove === 'function') marker.remove();
    else if (marker.parentNode) marker.parentNode.removeChild(marker);
    var rows = parsed.querySelectorAll('.min-cart-col');
    if ((snapshot.item_count > 0 && (!rows || rows.length === 0)) || (snapshot.item_count === 0 && rows && rows.length > 0)) return null;
    snapshot.rowsHtml = parsed.body.innerHTML;
    return snapshot;
  }

  function labelsFromHtml(html, Parser) {
    if (typeof html !== 'string' || typeof Parser !== 'function') return null;
    var parsed = new Parser().parseFromString(html, 'text/html');
    var markers = parsed && typeof parsed.querySelectorAll === 'function' ? parsed.querySelectorAll('[data-mdv-bag-snapshot]') : [];
    if (!markers || markers.length !== 1) return null;
    var labels = {
      refreshing: String(markers[0].getAttribute('data-label-refreshing') || '').trim(),
      unavailable: String(markers[0].getAttribute('data-label-unavailable') || '').trim(),
      error: String(markers[0].getAttribute('data-label-error') || '').trim()
    };
    return labels.refreshing && labels.unavailable && labels.error ? labels : null;
  }

  function shippingState(deliveryTotal, threshold) {
    var total = Number(deliveryTotal);
    var target = Number(threshold);
    if (!Number.isFinite(total) || !Number.isFinite(target) || target < 0 || total <= 0) return { kind: 'hidden' };
    if (total >= target) return { kind: 'qualified', total: total, threshold: target };
    return { kind: 'remaining', total: total, threshold: target, remaining: target - total };
  }

  function minOrderState(total, threshold, eligibleItemCount) {
    var cartTotal = Number(total);
    var target = Number(threshold);
    var count = Number(eligibleItemCount);
    if (!Number.isFinite(cartTotal) || !Number.isFinite(target) || target <= 0 || cartTotal >= target) return { kind: 'met' };
    if (!Number.isFinite(count) || count <= 0) return { kind: 'gift_card_only' };
    return { kind: 'blocked', threshold: target };
  }

  function cartDestinationUrl(cartPath, origin, pageSearch, expectedCountry) {
    var source;
    try { source = new URL(String(cartPath || '/cart'), origin); } catch (error) { return '/cart'; }
    var destination = source.pathname || '/cart';
    var country = countryQueryValue(pageSearch, expectedCountry);
    return country ? destination + '?country=' + encodeURIComponent(country) : destination;
  }

  function initialConfig(doc) {
    var marker = doc.querySelector('[data-mdv-bag-config]');
    if (!marker) return null;
    var config = {
      labels: {
        refreshing: String(marker.getAttribute('data-label-refreshing') || '').trim(),
        unavailable: String(marker.getAttribute('data-label-unavailable') || '').trim(),
        error: String(marker.getAttribute('data-label-error') || '').trim(),
        viewBag: String(marker.getAttribute('data-label-view-bag') || '').trim()
      },
      cartUrl: String(marker.getAttribute('data-cart-url') || '').trim()
    };
    return config.labels.refreshing && config.labels.unavailable && config.labels.error &&
      config.labels.viewBag && config.cartUrl ? config : null;
  }

  function createRuntime(win, doc, progress) {
    var generation = 0;
    progress = progress || {};
    var startingConfig = initialConfig(doc);
    var labels = startingConfig ? startingConfig.labels : null;
    var recoveryLabel = startingConfig ? startingConfig.labels.viewBag : '';
    var cartUrl = startingConfig ? startingConfig.cartUrl : '';
    var refreshTimeout = 10000;

    function nodes(selector) {
      return Array.prototype.slice.call(doc.querySelectorAll(selector));
    }

    function setDisplay(selector, visible) {
      nodes(selector).forEach(function (element) { element.style.display = visible ? '' : 'none'; });
    }

    function setCheckoutDisabled(disabled) {
      nodes('.min-cart-bottom .min-cart-checkout, .cart form a.button.cart_page_checkout').forEach(function (element) {
        element.classList.toggle('disable_checkout', disabled);
        element.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        if ('disabled' in element) element.disabled = disabled;
      });
    }

    function setSubtotal(value) {
      nodes('.cart-sub-price .cart-subtotal-price').forEach(function (element) {
        element.innerHTML = '';
        var heading = doc.createElement('h5');
        heading.textContent = value;
        element.appendChild(heading);
      });
    }

    function setUnresolved(message) {
      setCheckoutDisabled(true);
      setSubtotal(message);
      // Keep the current rows on screen while the bag refreshes (no flicker); checkout stays disabled until commit.
      nodes('.min-cart-main').forEach(function (element) { element.setAttribute('aria-busy', 'true'); });
    }

    function setError() {
      nodes('.min-cart-main').forEach(function (element) { element.removeAttribute('aria-busy'); });
      setCheckoutDisabled(true);
      setSubtotal(labels ? labels.unavailable : '');
      nodes('.min-cart-main').forEach(function (element) {
        element.innerHTML = '';
        if (labels) {
          var error = doc.createElement('p');
          error.setAttribute('data-mdv-bag-refresh-error', '');
          error.setAttribute('role', 'status');
          error.textContent = labels.error;
          element.appendChild(error);
          if (recoveryLabel && cartUrl) {
            var recovery = doc.createElement('a');
            recovery.setAttribute('data-mdv-bag-recovery', '');
            recovery.setAttribute('href', cartDestinationUrl(cartUrl,
              win.location && win.location.origin || 'https://' + String(win.location && win.location.hostname || ''),
              win.location && win.location.search, captureContext(win).country));
            recovery.textContent = recoveryLabel;
            element.appendChild(recovery);
          }
        }
        element.style.display = labels ? '' : 'none';
      });
      setDisplay('.min-cart-no-items', false);
      setDisplay('.min-cart-footer, .min-cart-bottom', Boolean(labels));
      setDisplay('.min-cart-message', false);
      if (typeof progress.reset === 'function') progress.reset();
    }

    function thresholdAttribute(context) {
      if (context.hostname === 'me.manieredevoir.com' && ['OM', 'BH', 'AE', 'SA', 'KW', 'QA'].indexOf(context.selectedCountry) !== -1) {
        return 'data-free-shipping-' + context.selectedCountry.toLowerCase();
      }
      var hostCountry = /^(sa|ae|kw|qa)\.manieredevoir\.com$/.exec(context.hostname);
      return hostCountry ? 'data-free-shipping-' + hostCountry[1] : 'data-free-shipping';
    }

    function uiConfig(context) {
      var shipping = doc.querySelector('.min-cart-message .min-cart-free-shipping');
      var minimum = doc.querySelector('.min-cart-message .min-cart-min-order');
      var shippingRaw = shipping ? shipping.getAttribute(thresholdAttribute(context)) : null;
      var minimumRaw = minimum ? minimum.getAttribute('minimum-order-price') : null;
      var shippingConfigured = shippingRaw !== null && shippingRaw !== '';
      var minimumConfigured = minimumRaw !== null && minimumRaw !== '';
      var shippingBase = shippingRaw === null || shippingRaw === '' ? null : nonNegativeInteger(shippingRaw);
      var minimumBase = minimumRaw === null || minimumRaw === '' ? null : nonNegativeInteger(minimumRaw);
      return {
        shipping: shipping,
        minimum: minimum,
        shippingBase: shippingBase,
        minimumBase: minimumBase,
        valid: (!shippingConfigured || shippingBase !== null) && (!minimumConfigured || minimumBase !== null),
        shippingMessage: shipping ? String(shipping.getAttribute('data-val') || '') : '',
        minimumMessage: minimum ? String(minimum.getAttribute('data-val') || '') : ''
      };
    }

    function formattedAmount(amount, context) {
      var format = doc.body && doc.body.getAttribute('data-shop-moneyformat');
      if (!(win.Shopify && typeof win.Shopify.formatMoney === 'function') || !format) return '';
      var moneyText = doc.createElement('template');
      moneyText.innerHTML = String(win.Shopify.formatMoney(amount, format));
      var formatted = moneyText.content.textContent || '';
      if (context.hostname === 'sa.manieredevoir.com' || context.selectedCountry === 'SA') return formatted.replace(/(\.00) SR$/, ' SR').replace(/\.00$/, '');
      if (context.hostname === 'ae.manieredevoir.com' || context.selectedCountry === 'AE') return formatted.replace(/(\.00) AED$/, ' AED').replace(/\.00$/, '');
      if (context.hostname === 'kw.manieredevoir.com' || context.selectedCountry === 'KW') return formatted.replace(/\.00$/, '');
      if (context.hostname === 'qa.manieredevoir.com' || context.selectedCountry === 'QA') return formatted.replace(/,00/, '');
      return formatted;
    }

    function convertedThreshold(base, context) {
      if (base === null) return null;
      if (!Number.isFinite(context.rate) || context.rate <= 0) return null;
      var value = base * context.rate;
      if (/^(sa|ae|kw|qa)\.manieredevoir\.com$/.test(context.hostname)) value = Math.floor(value / 100) * 100;
      return value;
    }

    function applyShipping(snapshot, context, config) {
      if (!config.shipping) return;
      var threshold = convertedThreshold(config.shippingBase, context);
      var state = shippingState(snapshot.delivery_qualifying_total, threshold);
      var success = nodes('.min-cart-message .min-cart-free-success');
      if (typeof progress.update === 'function') progress.update(snapshot.delivery_qualifying_total, threshold);
      if (state.kind === 'qualified') {
        config.shipping.style.display = 'none';
        success.forEach(function (element) { element.style.display = ''; });
      } else if (state.kind === 'remaining') {
        var amount = formattedAmount(state.remaining, context);
        if (!amount) {
          config.shipping.style.display = 'none';
          success.forEach(function (element) { element.style.display = 'none'; });
          return;
        }
        config.shipping.textContent = '';
        var span = doc.createElement('span');
        span.className = 'free_shipping_false';
        span.textContent = config.shippingMessage.replace('{{amount}}', amount);
        config.shipping.appendChild(span);
        config.shipping.style.display = '';
        success.forEach(function (element) { element.style.display = 'none'; });
      } else {
        config.shipping.style.display = 'none';
        success.forEach(function (element) { element.style.display = 'none'; });
      }
    }

    function applyMinimum(snapshot, context, config) {
      var threshold = convertedThreshold(config.minimumBase, context);
      var state = minOrderState(snapshot.total_price, threshold, snapshot.min_order_item_count);
      setCheckoutDisabled(false);
      if (!config.minimum || state.kind === 'met') {
        setDisplay('.min-cart-message .min_order_wrap', false);
        setDisplay('.min-cart-message .free_shipping_wrap', true);
        return;
      }
      if (state.kind === 'gift_card_only') {
        config.minimum.style.display = 'none';
        setDisplay('.min-cart-message .min_order_wrap', true);
        setDisplay('.min-cart-message .free_shipping_wrap', false);
        return;
      }
      var amount = formattedAmount(state.threshold, context);
      config.minimum.textContent = amount ? config.minimumMessage.replace('{{amount}}', amount) : (labels ? labels.error : '');
      config.minimum.style.display = '';
      setDisplay('.min-cart-message .min_order_wrap', true);
      setDisplay('.min-cart-message .free_shipping_wrap', false);
      setCheckoutDisabled(true);
    }

    function updateCount(count) {
      nodes('.header-navigation .cart .cart-count, .header-right-icon li.cart a .cart-count').forEach(function (element) { element.remove(); });
      nodes('[data-mdv-cart-count]').forEach(function (element) { element.setAttribute('data-mdv-cart-count', String(count)); });
      if (count <= 0) return;
      var targets = nodes('.header-right-icon li.cart a, .header-navigation .cart .header-navigation-name');
      targets.forEach(function (target) {
        var badge = doc.createElement('span');
        badge.className = 'cart-count';
        badge.textContent = String(count);
        target.appendChild(badge);
      });
      nodes('.header-right-icon .cart').forEach(function (element) { element.classList.add('active'); });
      win.setTimeout(function () {
        nodes('.header-right-icon .cart').forEach(function (element) { element.classList.remove('active'); });
      }, 1000);
    }

    function commit(snapshot, context, config) {
      nodes('.min-cart-main').forEach(function (element) { element.innerHTML = snapshot.rowsHtml; element.removeAttribute('aria-busy'); });
      if (/^(?:me|ae|sa|kw|qa)\.manieredevoir\.com$/.test(context.hostname) && typeof win.updateSizeForAU === 'function') {
        win.updateSizeForAU('.cart-content-meta span');
      }
      updateCount(snapshot.item_count);
      setSubtotal(snapshot.total_formatted);
      applyShipping(snapshot, context, config);
      applyMinimum(snapshot, context, config);
      var hasItems = snapshot.item_count > 0;
      setDisplay('.min-cart-no-items', !hasItems);
      setDisplay('.min-cart-main, .min-cart-footer, .min-cart-bottom, .min-cart-message', hasItems);
      nodes('.cart-page.not_add_data').forEach(function (element) { element.classList.remove('not_add_data'); });
    }

    function fetchTextWithDeadline(url, options) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
        var requestOptions = Object.assign({}, options || {});
        var timer = null;
        if (controller) requestOptions.signal = controller.signal;

        function finish(callback, value) {
          if (settled) return;
          settled = true;
          if (timer !== null && typeof win.clearTimeout === 'function') win.clearTimeout(timer);
          callback(value);
        }

        function failRead(error) {
          // Only failures from this read may retry; parsing/rendering faults must not.
          if (!error || typeof error.mdvBagRetryable !== 'boolean') {
            error = new Error('bag-refresh-transport');
            error.mdvBagRetryable = true;
          }
          finish(reject, error);
        }

        timer = win.setTimeout(function () {
          if (settled) return;
          var timeoutError = new Error('bag-refresh-timeout');
          timeoutError.mdvBagTimeout = true;
          timeoutError.mdvBagRetryable = true;
          settled = true;
          if (typeof win.clearTimeout === 'function') win.clearTimeout(timer);
          if (controller) {
            try { controller.abort(); } catch (error) {}
          }
          reject(timeoutError);
        }, refreshTimeout);

        try {
          Promise.resolve(win.fetch(url, requestOptions))
            .then(function (response) {
              if (!response.ok) {
                var httpError = new Error('bag-refresh-' + response.status);
                httpError.mdvBagRetryable = [408, 500, 502, 503, 504].indexOf(response.status) !== -1;
                throw httpError;
              }
              return response.text();
            })
            .then(function (html) { finish(resolve, html); }, failRead);
        } catch (error) {
          failRead(error);
        }
      });
    }

    function refresh() {
      var requestGeneration = ++generation;
      setUnresolved(labels ? labels.refreshing : '');

      // One fresh GET can recover a transient read or settling market context.
      // Keep both attempts in this generation so a newer cart update always wins.
      function attempt(retriesLeft) {
        if (requestGeneration !== generation) return Promise.resolve({ kind: 'stale' });
        var context = captureContext(win);
        var config = uiConfig(context);
        var rateRequired = config.shippingBase !== null || config.minimumBase !== null;
        if (!context.country || !context.currency || !config.valid || (rateRequired && context.rate === null) ||
            typeof win.fetch !== 'function' || typeof win.DOMParser !== 'function') {
          setError();
          return Promise.resolve({ kind: 'invalid_context' });
        }
        var url = context.root + 'cart?view=min-cart&t=' + Date.now();
        if (context.queryCountry) url += '&country=' + encodeURIComponent(context.queryCountry);
        return fetchTextWithDeadline(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (html) {
            if (requestGeneration !== generation) return { kind: 'stale' };
            labels = labelsFromHtml(html, win.DOMParser) || labels;
            if (!sameContext(context, captureContext(win))) {
              if (retriesLeft > 0) return attempt(retriesLeft - 1);
              setError();
              return { kind: 'context_changed' };
            }
            var snapshot = parseSnapshotHtml(html, context, win.DOMParser);
            if (!snapshot) {
              setError();
              return { kind: 'invalid_snapshot' };
            }
            commit(snapshot, context, config);
            return { kind: 'committed', snapshot: snapshot };
          })
          .catch(function (error) {
            if (requestGeneration !== generation) return { kind: 'stale' };
            if (retriesLeft > 0 && error && error.mdvBagRetryable === true) return attempt(retriesLeft - 1);
            setError();
            return { kind: error && error.mdvBagTimeout ? 'request_timeout' : 'request_failed' };
          });
      }

      return attempt(1);
    }

    return { refresh: refresh };
  }

  return {
    normalizedCode: normalizedCode,
    routeRoot: routeRoot,
    countryQueryValue: countryQueryValue,
    captureContext: captureContext,
    sameContext: sameContext,
    parseSnapshotHtml: parseSnapshotHtml,
    labelsFromHtml: labelsFromHtml,
    shippingState: shippingState,
    minOrderState: minOrderState,
    cartDestinationUrl: cartDestinationUrl,
    createRuntime: createRuntime
  };
})();
window.MDVBagContext = window.MDVBagContextCore.createRuntime(window, document, {
  reset: mdvResetFreeDeliveryProgress,
  update: mdvUpdateFreeDeliveryProgress
});
var mdvInventoryBagReviewGeneration = 0;
function mdvInventoryBagStatus(message) {
  document.querySelectorAll('.min-cart-footer').forEach(function(footer) {
    var status = footer.querySelector('[data-mdv-bag-inventory-status]');
    if (!message) {
      if (status) status.remove();
      return;
    }
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-mdv-bag-inventory-status', '');
      status.setAttribute('role', 'status');
      status.className = 'check-stock-msg active mdv-inventory-status';
      var checkout = footer.querySelector('.min-cart-bottom');
      var parent = checkout && checkout.parentNode;
      if (parent && footer.contains(checkout)) parent.insertBefore(status, checkout);
      else footer.appendChild(status);
    }
    status.textContent = message;
  });
}
function mdvInventoryReviewBag() {
  var gate = window.MDVInventoryGate;
  if (!gate || typeof gate.reviewCart !== 'function') return Promise.resolve({kind: 'unavailable'});
  var generation = ++mdvInventoryBagReviewGeneration;
  return gate.reviewCart().then(function(mode) {
    if (generation !== mdvInventoryBagReviewGeneration) return {kind: 'stale'};
    if (mode.kind === 'conflict') {
      mdvInventoryBagStatus(gate.label('mixedBag', 'Collection and delivery require separate orders. Remove one type before checkout.'));
    } else if (mode.kind === 'empty' || mode.kind === 'delivery' || mode.kind === 'collection') {
      mdvInventoryBagStatus('');
    }
    return mode;
  }).catch(function() { return {kind: 'unknown'}; });
}
function addcart() {
  return window.MDVBagContext.refresh().then(function(result) {
    if (result.kind !== 'committed') return result;
    return mdvInventoryReviewBag().then(function() { return result; });
  });
}
window.addEventListener('DOMContentLoaded', mdvInventoryReviewBag, {once: true});
$(document).on('click.mdvInventoryBagReview', '.header .cart', mdvInventoryReviewBag);
function mdvInventoryStatus(source, message, collection) {
  var container = source && source.closest ? source.closest('.product-page--cart-form, .min-cart-col, #product_add') : null;
  var status = container && container.querySelector('.check-stock-msg');
  var availability = window.__mdvStoreAvailabilityController;
  if (availability && typeof availability.setInventoryStatus === 'function' &&
      availability.setInventoryStatus(source, message || '', collection === true)) message = '';
  if (!status) return;
  status.textContent = message || '';
  status.classList.toggle('active', Boolean(message));
  status.classList.toggle('mdv-inventory-status', Boolean(message));
}
function mdvInventoryMessage(kind, detail) {
  var gate = window.MDVInventoryGate;
  if (!gate) return 'Please retry.';
  if (kind === 'delivery_bag') return gate.label('deliveryBag', 'Place collection items in a separate order.');
  if (kind === 'collection_bag') return gate.label('collectionBag', 'Place delivery items in a separate order.');
  if (kind === 'write_ambiguous') return gate.label('ambiguous', 'Check your bag before trying again.');
  if (kind === 'reconcile_required') return gate.label('reconcile', 'Check your bag and reload before adding more.');
  if (kind === 'write_rejected') return detail || gate.label('unavailable', 'This quantity is currently unavailable.');
  if (kind === 'unavailable' || kind === 'collection_changed') return gate.label('unavailable', 'This size is currently unavailable.');
  return gate.label('retry', 'We could not verify this bag. Please retry.');
}
function mdvInventoryAdd(source, variantId, action, cartItems, writeFn) {
  var gate = window.MDVInventoryGate;
  if (!gate || typeof gate.inputFromElement !== 'function') {
    mdvInventoryStatus(source, 'Please retry.');
    return Promise.resolve({kind: 'retry'});
  }
  var input = gate.inputFromElement(source, variantId);
  var expectedVariant = String(variantId);
  return gate.execute({
    action: action,
    input: input,
    properties: cartItems.items[0].properties || {},
    isCurrent: function () {
      if (!source || source.isConnected === false) return false;
      if (source.matches && source.matches('.min-cart-col')) return String(source.dataset.id || source.dataset.mdvVariantId) === expectedVariant;
      var form = source.closest && source.closest('form');
      var select = form && form.querySelector('select[name="id"], select#variant-listbox');
      return !select || String(select.value) === expectedVariant;
    }
  }, function (decision) {
    var guardedItems = {items: cartItems.items.map(function (item) {
      var copy = Object.assign({}, item);
      copy.properties = Object.assign({}, item.properties || {}, decision.properties || {});
      return copy;
    })};
    return writeFn(guardedItems);
  }).then(function (result) {
    if (result.kind === 'written' || result.kind === 'written_unconfirmed') {
      mdvInventoryStatus(source, '');
    } else if (result.kind !== 'collection_available' && result.kind !== 'stale') {
      mdvInventoryStatus(source, mdvInventoryMessage(result.kind, result.message));
    }
    return result;
  });
}
function mdvResetPdpInventoryPresentation() {
  window.setTimeout(function() {
    var gate = window.MDVInventoryGate;
    var button = document.querySelector('.product-page--cart-form #add');
    var select = document.querySelector('.product-page--cart-form select#variant-listbox');
    if (!gate || !button || !select) return;
    var nativeLabelNode = document.querySelector('#onClickContent');
    var nativeLabel = nativeLabelNode && nativeLabelNode.textContent.trim() || 'Add to Bag';
    if (gateCoreReset(button, select.value, nativeLabel)) {
      var status = document.querySelector('.product-page--cart-form .check-stock-msg.mdv-inventory-status');
      if (status) mdvInventoryStatus(button, '');
    }
  }, 0);
}
function gateCoreReset(button, variantId, nativeLabel) {
  var gate = window.MDVInventoryGate;
  return Boolean(gate && typeof gate.resetOwnedAddButton === 'function' &&
    gate.resetOwnedAddButton(button, String(variantId), nativeLabel));
}
$(document).on('click change', '.product-page--cart-form .size_swatch, .product-page--cart-form .size_swatch input', mdvResetPdpInventoryPresentation);
/* END MDV BAG CONTEXT RUNTIME V1 */
addcart();
// add cart product page
$('#add').click(function(e) {
  e.preventDefault();
  if($(".swatch").hasClass("selectsize")){
    $("#pleaseselectsize").css("display", "none");
  }else{
    if (this.dataset.mdvInventoryBusy === 'true') return;
    this.dataset.mdvInventoryBusy = 'true';
    var prodvariantid = $('.product-page-left-sec #variant-listbox').val();
    var quantity_prod = $(this).find('[name="quantity"]').val();
    // Gift card JS Start
    if(window.location.href.indexOf("gift-cards") !== -1){
         if ($("#Recipient-checkbox-template").prop('checked')==true){
          $(".err-on, .err-oe, .err-rn, .err-re, .err-rd").hide();
            if ($("#your-name-template").val() == ''){
              $(".err-on").show()
            }else if ($("#your-email-template").val() == '') {
              $(".err-oe").show()
            }else if ($("#Recipient-name-template").val() == '') {
              $(".err-rn").show()
            }else if ($("#Recipient-email-template").val() == '') {
              $(".err-re").show()
            }else if ($("#Recipient-send-on-template").val() == '') {
              $(".err-rd").show()
            }
            var OrdererEmail = $("#your-name-template").val();
            var OrdererName = $("#your-email-template").val();
            var RecipientEmail = $("#Recipient-email-template").val();
            var RecipientName = $("#Recipient-name-template").val();
            var RecipientMessage = $("#Recipient-message-template").val();
            var RecipientSendOn =  $("#Recipient-send-on-template").val().replace("/", "-").replace("/", "-");
            var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod, properties:{"__shopify_send_gift_card_to_recipient": "on", "Message": $("#Recipient-message-template").val(), "Recipient email": $("#Recipient-email-template").val(), "Recipient name": $("#Recipient-name-template").val(), "Send on": RecipientSendOn, "Orderer Name": $("#your-name-template").val(), "Orderer Email": $("#your-email-template").val() }}]};
          }else{
            var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};
          }
      }else{
        if($("#PreOrder").prop('checked') == true){
          var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod, properties: (window.mdvPreorderProps ? window.mdvPreorderProps() : {_pre_order: true})}]};
        }else{
          var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};
        }
      }
     var formNotSubmited = "false"
    // Gift card JS End
    var addButton = this;
    addButton.dataset.mdvPreorder = $("#PreOrder").prop('checked') === true ? 'true' : 'false';
    addButton.dataset.mdvInventoryVariant = String(prodvariantid);
    var collectionAction = addButton.dataset.mdvCollectionReady === String(prodvariantid);
    var nativeAddLabel = addButton.dataset.mdvNativeLabel || addButton.value;
    addButton.dataset.mdvNativeLabel = nativeAddLabel;
    addButton.disabled = true;
    addButton.value = 'Checking availability…';
    mdvInventoryAdd(addButton, prodvariantid, collectionAction ? 'collection' : 'delivery', cartItems, function(guardedItems) {
      return $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: guardedItems,
    error: function(xhr, status, error) {
      if(window.location.href.indexOf("gift-cards") !== -1){
        formNotSubmited = "true"
      }else{
        // alert(xhr.responseText);
        var VQTY = "#variant_qty_"+prodvariantid;
        var errorMessage = "Only 1 Available."
        $(".pdp.check-stock-msg").html(errorMessage.replace('1', $(VQTY).html())).addClass("active")
      }
    },
    success: function(data2) {
      if(window.location.href.indexOf("gift-cards") !== -1){
          if ($("#Recipient-checkbox-template").prop('checked')==true){
           if ($("#your-name-template").val() == ''){
             $(".err-on").show()
           }else if ($("#your-email-template").val() == '') {
             $(".err-oe").show()
           }else if ($("#Recipient-name-template").val() == '') {
             $(".err-rn").show()
           }else if ($("#Recipient-email-template").val() == '') {
             $(".err-re").show()
           }else if ($("#Recipient-send-on-template").val() == '') {
             $(".err-rd").show()
           }else{
             addcart();
             $(".send_as_gift .err-msg").hide()
             $("#your-name-template, #your-email-template, #Recipient-name-template, #Recipient-email-template, #Recipient-message-template").val('')
            //  if($(window).width() > 767){
                $(".min-cart").addClass("active");
                $("body").addClass("no-scroll");
                CSWishlistrefreshData();
                $(".cart_tab_link1").trigger('click');
            //  }
           }
          }else{
            addcart();
            //  if($(window).width() > 767){
                $(".min-cart").addClass("active");
                $("body").addClass("no-scroll");
                CSWishlistrefreshData();
                $(".cart_tab_link1").trigger('click');
            //  }
          }
        }else{
          addcart();
          // if($(window).width() > 767){
            $(".min-cart").addClass("active");
            $("body").addClass("no-scroll");
            CSWishlistrefreshData();
            $(".cart_tab_link1").trigger('click');
          // }
        }
    },
    complete: function() {},
  });
    }).then(function(result) {
      var currentVariant = String($('.product-page-left-sec #variant-listbox').val());
      if (currentVariant !== String(prodvariantid)) {
        var currentLabel = ($('#onClickContent').text() || 'Add to Bag').trim();
        gateCoreReset(addButton, currentVariant, currentLabel);
        return;
      }
      delete addButton.dataset.mdvInventoryBusy;
      delete addButton.dataset.mdvInventoryVariant;
      addButton.disabled = false;
      if (result.kind === 'collection_available') {
        addButton.dataset.mdvCollectionReady = String(prodvariantid);
        addButton.value = window.MDVInventoryGate.label('collectionButton', 'Add for collection at Dubai Mall');
        mdvInventoryStatus(addButton, window.MDVInventoryGate.label('collectionMessage', 'Available for collection at Dubai Mall.'), true);
      } else {
        delete addButton.dataset.mdvCollectionReady;
        addButton.value = nativeAddLabel;
      }
    }).catch(function() {
      var currentVariant = String($('.product-page-left-sec #variant-listbox').val());
      if (currentVariant !== String(prodvariantid)) {
        var currentLabel = ($('#onClickContent').text() || 'Add to Bag').trim();
        gateCoreReset(addButton, currentVariant, currentLabel);
        return;
      }
      delete addButton.dataset.mdvInventoryBusy;
      delete addButton.dataset.mdvInventoryVariant;
      addButton.disabled = false;
      addButton.value = nativeAddLabel;
      mdvInventoryStatus(addButton, mdvInventoryMessage('retry'));
    });
  }
});


// for add to cart
// $(document).on("click","a.mini-cart-add",function(event){
//   event.preventDefault();
//   $(this).parents(".min-cart-col").addClass("loader_active");
//   var prodvariantid = $(this).parents(".min-cart-col").find('select.recommendation-variant').val();
//   var quantity_prod = $(this).parents(".min-cart-col").find('.cart-content-quantity input').val();
//   var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};

//   $.ajax({
//     type: "post",
//     url: "/cart/add.js",
//     dataType: "json",
//     data: cartItems,
//     error: function(xhr, status, error) {
//       alert(xhr.responseText);
//     },
//     success: function(data2) {
//     },
//     complete: function() {
//       addcart();
//     },
//   });
// });
  
// for remove product from cart
$(document).on("click","a.cart-content-remove",function(event){
  event.preventDefault();
  $(this).parents(".min-cart-col").addClass("loader_active");
  var removevariantid = $(this).parents(".min-cart-col").attr('data-id');
  var variantObject = {};
  variantObject[removevariantid] = 0;
  var jsonObject = {}
  jsonObject['updates'] = variantObject;

  $.ajax({
    type: "post",
    url: "/cart/update.js",
    data: jsonObject,
    dataType: "json",
    success: function(data) {
      addcart();
    }
  }); 
});
  
// for increment of cart
$(document).on("click",".qty-plus.plus",function(event){
  event.preventDefault();
  
  if($(this).parents('.min-cart-main').length){
    var plusButton = this;
    if (plusButton.dataset.mdvInventoryBusy === 'true') return;
    plusButton.dataset.mdvInventoryBusy = 'true';
    $(this).parents(".min-cart-col").addClass("loader_active");
    var prodvariantid = $(this).parents(".min-cart-col").attr('data-id');
    var quantity_prod = 1;
    var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};

     var cartRow = $(this).parents('.min-cart-col').get(0);
     var plusAction = cartRow && cartRow.dataset.mdvCollection === 'true' ? 'collection' : 'delivery';
     mdvInventoryAdd(cartRow || plusButton, prodvariantid, plusAction, cartItems, function(guardedItems) {
       return $.ajax({
      type: "post",
      url: "/cart/add.js",
      dataType: "json",
      data: guardedItems,
      error: function(xhr, status, error) {
        // alert(xhr.responseText);
        var VQTY = $('.cart-quantity-box input[data-id="'+prodvariantid+'"]').val();
        var errorMessage = "Only 1 Available."
        $('.min-cart-main .min-cart-col[data-id="'+prodvariantid+'"] .check-stock-msg').html(errorMessage.replace('1', VQTY)).addClass("active")
      },
      success: function(data2) {
        addcart();
      },
      complete: function() {
        $(".min-cart-col").removeClass("loader_active");
      },
    });
     }).then(function(result) {
       delete plusButton.dataset.mdvInventoryBusy;
       $(cartRow).removeClass("loader_active");
       if (result.kind === 'collection_available') {
         mdvInventoryStatus(cartRow || plusButton, window.MDVInventoryGate.label('legacyCollection', 'Remove and add this item again for collection.'));
       }
     }).catch(function() {
       delete plusButton.dataset.mdvInventoryBusy;
       $(cartRow).removeClass("loader_active");
       mdvInventoryStatus(cartRow || plusButton, mdvInventoryMessage('retry'));
     });
    
  }else{
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) + 1;
    $(this).parents(".min-cart-col").find('.cart-content-quantity input').val(quantity_prod);
  }
});
  
// for decrement of cart
$(document).on("click",".qty-nag.minus",function(event){
  event.preventDefault();
  if ($(this).parents('.min-cart-main[aria-busy="true"]').length) return; // Ignore taps while the bag refreshes: the row quantity is stale and this handler writes an absolute quantity.

  if($(this).parents('.min-cart-main').length){
    $(this).parents(".min-cart-col").addClass("loader_active");
    var removevariantid = $(this).parents(".min-cart-col").attr('data-id');
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) - 1;
    var variantObject = {};
    variantObject[removevariantid] = quantity_prod;
    var jsonObject = {}
    jsonObject['updates'] = variantObject;

    $.ajax({
      type: "post",
      url: "/cart/update.js",
      data: jsonObject,
      dataType: "json",
      success: function(data) {
        addcart();
      }
    });
  }else{
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) - 1;
    if(quantity_prod){
      $(this).parents(".min-cart-col").find('.cart-content-quantity input').val(quantity_prod);
    }
  }
});

// for add to cart in outfit // cross-sell grid product page
function mdvGridAdd(source, collectionAction) {
  if (source.dataset.mdvInventoryBusy === 'true') return;
  source.dataset.mdvInventoryBusy = 'true';
  var metaSource = source;
  var prodvariantid = source.dataset.mdvVariantId || source.getAttribute('value');
  if (source.matches('.mdv-inventory-collection-action')) {
    var form = source.closest('form');
    metaSource = form && form.querySelector('.variant-size[value="' + prodvariantid + '"]') || source;
  }
  var cartItems = {items: [{id:prodvariantid, quantity:1}]};
  source.disabled = true;
  mdvInventoryAdd(metaSource, prodvariantid, collectionAction ? 'collection' : 'delivery', cartItems, function(guardedItems) {
    return $.ajax({
      type: 'post',
      url: '/cart/add.js',
      dataType: 'json',
      data: guardedItems,
      error: function() {
        var VQTY = $(metaSource).attr('data-vqty');
        var errorMessage = 'Only 1 Available.';
        $(metaSource).parents('#product_add').find('.check-stock-msg').html(errorMessage.replace('1', VQTY)).addClass('active');
      },
      success: function() {
        addcart();
        if($(window).width() > 767){
          $('.min-cart').addClass('active');
          $('body').addClass('no-scroll');
          CSWishlistrefreshData();
          $('.cart_tab_link1').trigger('click');
        }
        if($('.cart_tab2 .cart-recommended-option-ul').length) $('.cart_tab2 .cart-recommended-option-ul').hide();
      }
    });
  }).then(function(result) {
    delete source.dataset.mdvInventoryBusy;
    source.disabled = false;
    var form = metaSource.closest('form');
    if (result.kind === 'collection_available' && form) {
      var button = form.querySelector('.mdv-inventory-collection-action');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'button--secondary addToCartBtn mdv-inventory-collection-action';
        form.appendChild(button);
      }
      Object.keys(metaSource.dataset).forEach(function(key) { button.dataset[key] = metaSource.dataset[key]; });
      button.dataset.mdvVariantId = String(prodvariantid);
      button.textContent = window.MDVInventoryGate.label('collectionButton', 'Add for collection at Dubai Mall');
      mdvInventoryStatus(metaSource, window.MDVInventoryGate.label('collectionMessage', 'Available for collection at Dubai Mall.'));
    } else if (result.kind === 'written' || result.kind === 'written_unconfirmed') {
      if (form) {
        var existing = form.querySelector('.mdv-inventory-collection-action');
        if (existing) existing.remove();
      }
    }
  }).catch(function() {
    delete source.dataset.mdvInventoryBusy;
    source.disabled = false;
    mdvInventoryStatus(metaSource, mdvInventoryMessage('write_ambiguous'));
  });
}
$(document).on('click', '.outfit-product-item #variant-listbox ul li.variant-size, .cross-sell-item #variant-listbox ul li.variant-size', function(e) {
  e.preventDefault();
  mdvGridAdd(this, false);
});
$(document).on('click', '.mdv-inventory-collection-action', function(e) {
  e.preventDefault();
  mdvGridAdd(this, true);
});

// for change image and url on click and hover
$(document).on('mouseenter click', '.color-square-item .main_colors_wrapper .product-alt-colours a', function(e) {
  // e.preventDefault();
  $(this).closest(".color-square-item").find(".color-square-item-href").attr('href', $(this).attr('href'));
  $(this).closest('.color-square-item').find('.color-square-item-image-main').find('img').eq(0).attr({src: $(this).data('img1-src'), srcset: $(this).data('img1-src')});
  $(this).closest('.color-square-item').find('.color-square-item-image-main').find('img').eq(1).attr({src: $(this).data('img1-src'), srcset: $(this).data('img2-src')});

});

$(document).on('mouseleave', '.color-square-item .main_colors_wrapper .product-alt-colours a', function(e) {
  // e.preventDefault();
  var targetEl = ".hide-"+$(this).closest(".color-square-item").find('.main_colors_wrapper').attr('check-current');
  $(this).closest(".color-square-item").find('.color-square-item-image-main img').eq(0).attr({src: $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img1-src'), srcset: $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img1-src')});
  $(this).closest(".color-square-item").find('.color-square-item-image-main img').eq(1).attr({src: $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img2-src'), srcset: $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img2-src')});
  $(this).closest(".color-square-item").find(".color-square-item-href").attr('href', $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('href'));
});
// Accordion Js
$(".cart-popup #container h2, .template-page h2").click(function() {
  $(this).toggleClass("open-accordion");
  $(this).next('blockquote').toggleClass("highlighted");
});


// Search Box
function PosEnd(end) {
        var len = end.value.length;
         
        // Mostly for Web Browsers
        if (end.setSelectionRange) {
            end.focus();
            end.setSelectionRange(len, len);  
        } else if (end.createTextRange) {
            var t = end.createTextRange();
            t.collapse(true);
            t.moveEnd('character', len);
            t.moveStart('character', len);
            t.select();
        }
    }
/* mdv-search-modal-integration-v4:start */
window.mdvSearchFocusSync = "mdvSearchFocusSync-1.1";
$(document)
  .off("click.mdvSearchV3", "li.search, .toggol-menu-search")
  .on("click.mdvSearchV3", "li.search, .toggol-menu-search", function (e) {
    e.preventDefault();
    const $searchBox = $(".search-desk-box");
    if (!$searchBox.length) return;

    const opener = this.closest(".toggol-menu")
      ? document.querySelector(".header-toggle")
      : this.querySelector("a, button, input, [tabindex]") || this;
    const searchRoot = $searchBox.find("[data-mdv-search]").get(0);
    if (searchRoot && searchRoot.mdvSearch) searchRoot.mdvSearch.modalOpener = opener;
    if (opener && opener.setAttribute && !this.closest(".toggol-menu")) {
      opener.setAttribute("aria-controls", "mdv-search-modal");
      opener.setAttribute("aria-expanded", "true");
    }

    $("body").addClass("search-open");
    $searchBox.show().addClass("active").attr("aria-hidden", "false");
    $(".main-wrapper").addClass("active");
    $(".toggol-menu").removeClass("active");
    if (searchRoot && searchRoot.mdvSearch && typeof searchRoot.mdvSearch.activatePopularImages === "function") {
      searchRoot.mdvSearch.activatePopularImages();
    }

    const sidebarInput = this.closest(".toggol-menu") ? this.querySelector("input") : null;
    const query = sidebarInput ? sidebarInput.value : "";
    const input = document.querySelector(".search-desk-box .mdv-search__input");
    if (!input) return;
    if (query) {
      input.value = query;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      sidebarInput.value = "";
    }
    // Burger path: the a11y module inerted the modal while the menu was open and only
    // un-inerts at the next microtask (MutationObserver). Clear it on the modal alone so
    // the focus below happens inside this tap; the module's own close pass restores
    // the recorded value (false) and never re-inerts a closed menu's siblings.
    const modalEl = $searchBox.get(0);
    if (this.closest(".toggol-menu") && modalEl && modalEl.inert === true) modalEl.inert = false;
    input.removeAttribute("readonly");
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    requestAnimationFrame(() => {
      if (!input.isConnected || !$searchBox.hasClass("active")) return;
      if (document.activeElement !== input) input.focus({ preventScroll: true });
    });
  });

$(document)
  .off("keydown.mdvSidebarSearch", ".toggol-menu-search input")
  .on("keydown.mdvSidebarSearch", ".toggol-menu-search input", function (event) {
    if (event.key !== "Enter" || (event.originalEvent && event.originalEvent.isComposing) || event.which === 229) return;
    event.preventDefault();
    $(this).trigger("click");
  });

$(document)
  .off("click.mdvSearchV3", ".search-desk-close, .search-desk-box .main-overlay, .min-cart .main-overlay, .header .cart, .toggol-menu .main-overlay")
  .on("click.mdvSearchV3", ".search-desk-close, .search-desk-box .main-overlay, .min-cart .main-overlay, .header .cart, .toggol-menu .main-overlay", function () {
    const opensMiniCart = this.classList && this.classList.contains("cart");
    const shouldRestoreSearchFocus = $(this).is(".search-desk-close, .search-desk-box .main-overlay");
    let searchReturnFocus = null;
    document.querySelectorAll(".search-desk-box [data-mdv-search]").forEach(function (root) {
      if (!root.mdvSearch) return;
      if (shouldRestoreSearchFocus && !searchReturnFocus) searchReturnFocus = root.mdvSearch.modalOpener;
      if (typeof root.mdvSearch.closeFilters === "function") root.mdvSearch.closeFilters();
      if (typeof root.mdvSearch.resetSession === "function") root.mdvSearch.resetSession();
    });
    document.body.classList.remove("mdv-search-filter-open");
    $(".search-desk-box").removeClass("active").attr("aria-hidden", "true");
    document.querySelectorAll('[aria-controls="mdv-search-modal"]').forEach(function (opener) {
      opener.setAttribute("aria-expanded", "false");
    });
    $("body").removeClass("search-open");
    $(".main-wrapper").removeClass("active");
    if (!opensMiniCart) {
      $(".min-cart").removeClass('active');
      $("body").removeClass("no-scroll");
    }
    if (shouldRestoreSearchFocus && searchReturnFocus && searchReturnFocus.isConnected) {
      requestAnimationFrame(function () {
        searchReturnFocus.focus({ preventScroll: true });
      });
    }
    if($('.productHandlesByCategory[data-name="newCategory"]').length > 0){
      $('.productHandlesByCategory[data-name="newCategory"]').remove()
      $('.cs-wishlist-wrapper').css('overflow', 'auto');
    }
    CSWishlistrefreshData();
    if($("#csws-create-list").length){
        $("#csws-create-list").removeAttr("disabled");
    }
  });
$(document)
  .off('touchstart.mdvSearchV3', '.search-desk-box .mdv-search__input')
  .on('touchstart.mdvSearchV3', '.search-desk-box .mdv-search__input', function () {
    $(this).focus();
  });
/* mdv-search-modal-integration-v4:end */


// for form validation start
$(document).on('keyup', '#create_customer input#first_name,#create_customer input#last_name', function (event) {
    var userinput = $(this).val();
    var pattern = /[^a-zA-Z ]/;
    
    if(!pattern.test(userinput))
    {
        $(this).next(".custom_error").remove();
        if($("#create_customer .custom_error").length == 0){
          $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').removeClass("disabled");
          $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').removeAttr("disabled");
        }
    }else{
        $(this).next(".custom_error").remove();
        $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
        $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').addClass("disabled");
        $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
    }
});
$(document).on('keyup', '#customer-addresses input[name="address[first_name]"],#customer-addresses input[name="address[last_name]"]', function (event) {
    var userinput = $(this).val();
    var pattern = /[^a-zA-Z ]/;
    
    if(!pattern.test(userinput))
    {
        $(this).next(".custom_error").remove();
        if($("form .custom_error").length == 0){
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeClass("disabled");
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeAttr("disabled");
        }
    }else{
        $(this).next(".custom_error").remove();
        $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
        $(this).parents("form").find('.action_bottom input[type="submit"]').addClass("disabled");
        $(this).parents("form").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
    }
});
$(document).on('keyup', '#customer-addresses input[name="address[address1]"],#customer-addresses input[name="address[address2]"]', function (event) {
    var userinput = $(this).val();
    var pattern = /[^a-zA-Z0-9 ,-/:.]/;
    
    if(!pattern.test(userinput))
    {
        $(this).next(".custom_error").remove();
        if($("form .custom_error").length == 0){
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeClass("disabled");
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeAttr("disabled");
        }
    }else{
        $(this).next(".custom_error").remove();
        $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
        $(this).parents("form").find('.action_bottom input[type="submit"]').addClass("disabled");
        $(this).parents("form").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
    }
});
// for form validation end
  
// load more function 
var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute(force, $button, onSettled) {
  if(force || ($(document).height() - 1500 < ($(document).scrollTop() + $(window).height()))) {
    var loadingImage;
    // This theme renders several alternate collection-layout variants into the
    // DOM at once (observed: two parallel ".main-collection-section.without_tab"
    // instances, plus tabbed/custom-scroll variants elsewhere), and more than one
    // can be simultaneously "visible" by CSS display/offset even though only the
    // one the shopper actually clicked matters. Scope everything to that specific
    // button's own section so a single load only ever touches its own grid/button,
    // never a duplicate section elsewhere on the page.
    var pInfScrSection = $button ? $button.closest('.main-collection-section') : $();
    var pInfScrNode = pInfScrSection.find('.collection_load_more_wrapper').first();
    var pInfScrGrid = pInfScrSection.find('.scroll_product').first();
    var pInfScrURL = pInfScrNode.find('.collection-load-more-button').attr("data-href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrURL != '') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrSection.find('.collection-load-more-icon').append('<img src="https://cdn.shopify.com/s/files/1/0282/6678/files/navigation_animation-brown.gif" alt="logo brown" class="img-fluid" loading="lazy" />');
          pInfScrSection.find('.collection-load-more-button-container').hide();
        },
        success: function(data) {
          var filteredData = $(data).find(".scroll_product").html();
          var load_btn = $(data).find(".collection_load_more_wrapper").html();
          var load_btn_href = $(data).find(".collection-load-more-button").attr('data-href');
          var append_count = $(data).find('.main-product-item').length +1 ;
          pInfScrGrid.append(filteredData);
          // The fetched page's own HTML carries a second .collection_load_more_wrapper
          // (Shopify re-renders it inside .scroll_product whenever paginate.next
          // exists) -- appended wholesale above, that stray copy is never touched
          // again and is left behind mid-grid as a narrow flex-child, breaking the
          // row layout. Sweep it out; the one wrapper we keep and update below is
          // the original.
          pInfScrGrid.find('.collection_load_more_wrapper').not(pInfScrNode).remove();
          // Replace this wrapper's own content in place (rather than removing it
          // and re-selecting by class) so the fix stays correct even though
          // multiple same-class wrappers exist elsewhere in the DOM.
          pInfScrNode.html(load_btn || '');
          // Move it back to the end of the grid -- it never relocates on its own,
          // so after the first append it would otherwise sit permanently after
          // page 1's cards while every later page's cards render below it.
          pInfScrNode.appendTo(pInfScrGrid);
          pInfScrLoading = false;
          CSWishlistrefreshData();
          initializeSwiperForMobile(pInfScrGrid[0]);

          //Add this function for currency convert on load 11-11-2025 Start
          if(typeof cookieCurrency !== 'undefined' && cookieCurrency){
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
          //Add this function for currency convert on load 11-11-2025 Over
          if (typeof window.mdvApplySaleFilter === 'function') window.mdvApplySaleFilter(pInfScrSection);
          if (typeof onSettled === 'function') onSettled(true);
        },
        error: function(){
          // Restore the button and clear the spinner so a failed request doesn't
          // leave the load-more control stuck in a loading state (button hidden,
          // spinner spinning) with no way to retry.
          pInfScrSection.find('.collection-load-more-icon').empty();
          pInfScrSection.find('.collection-load-more-button-container').show();
          pInfScrLoading = false;
          if (typeof onSettled === 'function') onSettled(false);
        },
        complete: function(){
          loadSwatches();
          setTimeout(function() {
              loadSwatches();
          }, 1000);
        },
        dataType: "html"
      });
    } else if (typeof onSettled === 'function') {
      onSettled(false);
    }
  }
}
// new-collection-page.liquid's mdvAutoLoadForSale calls this across script
// contexts (it's closure-scoped to this file's own ready() wrapper otherwise
// and unreachable as a bare global, so the guard there always failed and the
// eager-load-more-under-a-sale-filter feature never ran).
window.pInfScrExecute = pInfScrExecute;

$('body').on('click','.collection-load-more-button',function(){
  // Explicit button clicks must always load the next page, regardless of scroll
  // position. The scroll-gate inside pInfScrExecute() is a leftover from an
  // infinite-scroll implementation that is no longer wired to any scroll handler
  // (the only $(window).scroll handler drives the sticky header). Without forcing
  // it, a click could silently do nothing -- e.g. on collections that render a
  // tall description below the grid, which pushes the button >1500px above the
  // document bottom so the gate never passes.
  pInfScrExecute(true, $(this));
});
});

function everyTime() {
  if ($(".intl-tel-input.iti-container").length > 0) {
     var x = $(".flag-container").offset();
     var toppx = x.top+6+"px";
     var leftpotion = $(window).width() - $(".om-outer-canvas .om-canvas").width() - 40
          newleftpotion = leftpotion+"px"
      var sidebarvidth = $(".om-outer-canvas .om-canvas").width()
          newsidebarvidth = sidebarvidth+"px";
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("left", newleftpotion);
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("top",toppx);
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("max-width",newsidebarvidth);
      $(".intl-tel-input.iti-container").addClass("active");
  }
}
document.addEventListener("DOMContentLoaded", function () {
    const navItem = document.querySelector('.bfsale-nav > a:not(.active)');

    if (navItem) {
        navItem.click();
    }
});


// show collection in search popup
function collectionSearchresult(selected_vendor) {
  $('.search-collection').hide();
  var query = $('input#Search').val();

  $.ajax({
    url: `/search/suggest?q=${query}&section_id=search-collection`,
    type: 'GET',
    dataType: 'html',
    success: function (response) {

      if (!response) {
        $(".search-collection .desk-result-row").html(`<p class="search-no-result">
        Sorry, Nothing Found For collection
        <strong>"${query}"</strong>
      </p>`);
      $('.search-collection').show();
        return;
      }

      $(".search-collection").empty().append(response);

      const accessoryKeywords = ['accessories','bags','headwear','gloves-mittens','ties-cufflinks','scarfs','scarf','sunglasses','belts','jewellery','lifestyle','hats','gloves','footwear'];

      $('.search-collection-attribute').each(function () {
        const handle = $(this).data('collection-handle');
        if (!handle) return;

        const isAccessory = accessoryKeywords.some(keyword =>
          handle.includes(keyword)
        );

        // MAN TAB
        if (selected_vendor === 'man') {
          if (!handle.startsWith('mens-') || isAccessory) {
            $(this).remove();
          }
        }

        // WOMAN TAB
        else if (selected_vendor === 'woman') {
          if (!handle.startsWith('womens-') || isAccessory) {
            $(this).remove();
          }
        }

        // ACCESSORIES TAB
        else if (selected_vendor === 'accessories') {
          if (!isAccessory) {
            $(this).remove();
          }
        }
      });

      // If nothing left after filtering
      if ($('.search-collection-attribute').length === 0) {
        $(".search-collection .desk-result-row").html(`<p class="search-no-result">
        Sorry, Nothing Found For collection
        <strong>"${query}"</strong>
      </p>`);
      }

      $('.search-collection').show();
    },
    error: function () {
      $(".search-collection").empty();
    }
  });
}


// COLOR LINK AUTOMATION
window.loadSwatches=(function(){
	const API="https://maniere-de-voir-au.myshopify.com/api/2026-01/graphql.json";
	const TOKEN="ad44223704b9bb05ed9880d93d673752";
	const PARALLEL_LIMIT=10;
	const cache={};
	// MDV_GILETS_IMAGE_MAP_SHA256=ac4363f8359eac6c4d219027de75528809e1fe8e078123dc411ccc0a5eaf9c25
	const MDV_GILETS_IMAGE_MAP_SHA256="ac4363f8359eac6c4d219027de75528809e1fe8e078123dc411ccc0a5eaf9c25";
	const mdvGiletsImageOverrides={"gid://shopify/Product/9107676004566":["https://cdn.shopify.com/s/files/1/0630/4261/7558/files/Mens-Sept-_0140_MAN3481.1-01MDV3-2_4438ae0b-f2ba-4ee8-ad31-e1e52f4a50fa.jpg?v=1791345102","https://cdn.shopify.com/s/files/1/0630/4261/7558/files/Mens-Sept-_0138_MAN3481.1-01MDV4-2_eb04908d-3af5-42d0-9189-3ca0bd2107a7.jpg?v=1791345102"],"gid://shopify/Product/9107676528854":["https://cdn.shopify.com/s/files/1/0630/4261/7558/files/MDV_0100_MDV3.2.jpg?v=1787650868","https://cdn.shopify.com/s/files/1/0630/4261/7558/files/MDV_0095_NEW-MDV3.2.jpg?v=1787650868"],"gid://shopify/Product/9467358773462":["https://cdn.shopify.com/s/files/1/0630/4261/7558/files/Mens-Sept-_0131_MAN3481.2-04MDV3-2_4ced13c3-bee5-4364-bbc7-cb9f50ac202e.jpg?v=1788551797","https://cdn.shopify.com/s/files/1/0630/4261/7558/files/Mens-Sept-_0129_MAN3481.2-04MDV4-2_19d3a0f3-fb9a-4474-b1f3-604505845505.jpg?v=1791267603"]};
	const genderMatchRules=["Vienna","TS001","VS001", "L'Eiffel","Sidney"];

	function handleize(str){
		return str.toLowerCase().trim().replace(/['"]/g,"").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"").replace(/-+/g,"-");
	}

	function isBorderColor(color){
		return ["white","multi","cream","ivory"].includes(color.toLowerCase());
	}

	function getColor(options){
		const opt=options?.find(o=>["color","colour"].includes(o.name.toLowerCase()));
		return opt?opt.values:[];
	}

	function getImages(images){
		return images?.edges?.map(e=>e.node.url)||[];
	}

	function getFirstSKU(variants){
		return variants?.edges?.[0]?.node?.sku||"";
	}

	async function searchProducts(keyword){

		if(cache[keyword]) return cache[keyword];

		const res=await fetch(API,{
			method:"POST",
			headers:{
				"Content-Type":"application/json",
				"X-Shopify-Storefront-Access-Token":TOKEN
			},
			body:JSON.stringify({
				query:`
				query ($q: String!) {
					search(query: $q, first: 50, types: PRODUCT) {
						edges {
							node {
								... on Product {
									id
									title
									handle
									vendor

									gender: metafield(namespace:"custom",key:"gender"){
										value
									}

									options{
										name
										values
									}

									images(first:2){
										edges{
											node{
												url
											}
										}
									}

									variants(first:1){
										edges{
											node{
												sku
											}
										}
									}
								}
							}
						}
					}
				}
				`,
				variables:{
					q:keyword
				}
			})
		});

		const data=await res.json();

		const products=data?.data?.search?.edges?.map(e=>e.node)||[];

		console.log("GRAPHQL RESULT",keyword,products);

		cache[keyword]=products;

		return products;

	}

	function createHTML(product){

		return product.colors.map(color=>{

			const colorHandle=handleize(color);

			const borderClass=isBorderColor(color)
			?" borderadded"
			:"";

			return `<a href="/products/${product.handle}" title="${product.title}" class="hide-${product.handle}" data-img1-src="${product.images[0]||''}" data-img2-src="${product.images[1]||''}" data-itemhandle="${product.handle}">
				<div class="swatch-element" hidethis="${product.handle}">
					<div style="width:20px;height:20px;background-color:${color};" class="selected swatch-element color ${colorHandle}${borderClass}"></div>
				</div>
			</a>`;

		}).join("");

	}

	async function processWrapper(wrapper){

		const $wrapper=$(wrapper);
		const useGiletsImageOverride=$wrapper.closest('.main-product-item').attr('data-mdv-gilets-image-override')==='true';

		if($wrapper.attr("data-mdv-processing")) return;

		$wrapper.attr("data-mdv-processing","true");

		const titleKeyword=$wrapper.attr("data-title")?.trim();

		const skuKeyword=$wrapper.attr("data-sku")?.trim();

		const currentGender=$wrapper.attr("data-gender")
		?.trim()
		?.toLowerCase()
		?.replace(/\s+/g,"");

		let type="";
		let searchKey="";

		if(titleKeyword){

			type="title";
			searchKey=titleKeyword;

		}else if(skuKeyword){

			type="sku";
			searchKey=skuKeyword.split("-")[0];

		}else{

			return;

		}

		console.log("PROCESS START",{
			type,
			searchKey,
			currentGender
		});

		const products=await searchProducts(searchKey);

		let matchedProducts=[];

		if(type==="title"){

			matchedProducts=products.filter(product=>{

				const productKeyword=product.title
				.split(" - ")[0]
				.trim()
				.toLowerCase();

				if(productKeyword!==searchKey.toLowerCase()) return false;

				if(genderMatchRules.includes(searchKey)){

					const productGender=product.gender?.value
					?.trim()
					?.toLowerCase()
					?.replace(/\s+/g,"")||"";

					console.log("TITLE GENDER CHECK",{
						searchKey,
						productTitle:product.title,
						productGender,
						currentGender
					});

					return productGender===currentGender;

				}

				return true;

			});

		}else{

			matchedProducts=products.filter(product=>{

				const skuPrefix=getFirstSKU(product.variants)
				.split("-")[0]
				.trim()
				.toLowerCase();

				if(skuPrefix!==searchKey.toLowerCase()) return false;

				if(genderMatchRules.includes(searchKey)){

					const productGender=product.gender?.value
					?.trim()
					?.toLowerCase()
					?.replace(/\s+/g,"")||"";

					console.log("SKU GENDER CHECK",{
						searchKey,
						productTitle:product.title,
						productGender,
						currentGender
					});

					return productGender===currentGender;

				}

				return true;

			});

		}

		console.log("MATCHED PRODUCTS",searchKey,matchedProducts);

		if(matchedProducts.length<2){

			console.log("LESS THAN 2 PRODUCTS",searchKey);

			return;

		}

		let html="";

		matchedProducts.forEach(product=>{

			html+=createHTML({
				title:product.title,
				handle:product.handle,
				colors:getColor(product.options),
				images:useGiletsImageOverride&&mdvGiletsImageOverrides[product.id]?mdvGiletsImageOverrides[product.id]:getImages(product.images)
			});

		});

		console.log("FINAL HTML",searchKey,html);

		$wrapper.find(".product-alt-colours").html(html);

	}

	return async function(){

		const wrappers=$(".main_colors_wrapper").toArray();

		console.log("TOTAL WRAPPERS",wrappers.length);

		if(!wrappers.length) return;

		await processWrapper(wrappers[0]);

		for(let i=1;i<wrappers.length;i+=PARALLEL_LIMIT){

			const batch=wrappers.slice(i,i+PARALLEL_LIMIT);

			await Promise.all(
				batch.map(wrapper=>
					processWrapper(wrapper)
				)
			);

		}

	};

})();

loadSwatches();

/* MDV pre-order: visible "Ships by" line. Only used when the product is tagged Pre-Order.
   Reads the date from <p class="mdv-preorder-note" data-dispatch="YYYY-MM-DD"> in the description. */
window.mdvPreorderProps = function(){
  var props = { _pre_order: true };
  try {
    var el = document.querySelector('.mdv-preorder-note[data-dispatch]');
    var raw = el ? el.getAttribute('data-dispatch') : null;
    if (raw && /^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      var p = raw.split('-'), d = new Date(Date.UTC(+p[0], +p[1]-1, +p[2]));
      var m = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      props['Pre-order'] = 'Ships by ' + d.getUTCDate() + ' ' + m[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
    }
  } catch (e) {}
  return props;
};
